document.addEventListener("DOMContentLoaded", () => {

    


    document.querySelectorAll('#menu-flotante').forEach(($menu) => {

        // LINKS
        const $links = $menu.querySelectorAll('li');
        
        $links.forEach(function ($link) {
            //console.log($link);
          });

        

    });


    //ANIMACIÓN DE ENLACES ANCLA
    document.querySelectorAll('#menu-flotante li a').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelectorAll('#menu-flotante li a').forEach(($menu) => {
                $menu.classList.remove('activo');
            });

            this.classList.add('activo');

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth',
            });

            //setTimeout(() => {
                //window.scrollBy(0, -30); // Ajusta este valor según sea necesario
            //}, 500);
        });
    });


    


});


document.addEventListener("scroll", () => {
    const corazon = document.querySelector("._corazon_");
    const menu_flotante = document.querySelector("#menu-flotante");
    const distance_corazon = corazon.getBoundingClientRect().top;

    if (distance_corazon <= 150) {
        menu_flotante.classList.add('fijo_');
    } else {
        menu_flotante.classList.remove('fijo_');
    }

    let found = false;

    document.querySelectorAll('#menu-flotante li a').forEach(($menu) => {
        const href = $menu.getAttribute('href');
        const anchor_ = href.split('#')[1];
        const elem = document.getElementById(anchor_);

        if (elem) {
            const elTop = elem.getBoundingClientRect().top;
            const elBottom = elem.getBoundingClientRect().bottom;

            // Verificar si el elemento está dentro de la vista
            if (!found && elTop <= window.innerHeight && elBottom > 0) {
                document.querySelectorAll('#menu-flotante li a').forEach(($menu_) => {
                    $menu_.classList.remove('activo');
                });
                $menu.classList.add('activo');
                found = true;
            } else {
                $menu.classList.remove('activo');
            }
        }
    });
});






